import MetaHeader from '../components/common/MetaHeader';
import ALink from '../components/common/ALink';

export default function DamagedItems() {
  return (
    <>
    <MetaHeader title={'Damaged Items'}/>
    <main className="main">
      <nav aria-label="breadcrumb" className="breadcrumb-nav mb-0">
        <div className="container">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <ALink href="/">Home</ALink>
            </li>
            <li className="breadcrumb-item">
              <ALink href="#">Pages</ALink>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              Damaged Items
            </li>
          </ol>
        </div>
      </nav>

      <div className="container">
        <p className="subpage">
          <h1 className="subpage__title">Damaged Items</h1>
          <div className="subpage__section">
            <p className="subpage__paragraph">
              If a box arrives damaged, customers are required to take pictures of the damage to the box and any other applicable packaging.  Images must be clear and show the full sides and edges of the box and packaging.  Pictures of the internal packaging are also required in order to demonstrate that external damage lead through to the internal damage of the item/s.  Pictures of the damaged item/s are also required, and the images must also be clear and show all sides and edges of the damaged item/s.  BuyOnTrust reserves the right to request any additional images and/or information as part of its investigation, and to assist the manufacturer, lease provider, and any/all other involved parties in their investigations.  BuyOnTrust reserves the right to issue or not issue any refunds, discounts, lease adjustments, and/or cancellations at its discretion.  BuyOnTrust often yields to the manufacturer and/or lease provider in making the ultimate determination on resolution.
            </p>
          </div>
          <div className="subpage__section">
            <p className="subpage__paragraph bolder">
              Customers are required to email:
              <a
                  href="mailto:info@buyontrust.com"
                  style={{
                    marginLeft: '4px',
                    color: '#4f4f4f',
                    fontWeight: '600'
                  }}>
                info@buyontrust.com
              </a>
            </p>
            <p className="subpage__paragraph bolder">
              Subject line:
              <a
                  style={{
                    marginLeft: '4px',
                    color: '#4f4f4f',
                    fontWeight: '600'
                  }}>
                Damage
              </a>
            </p>
            <p className="subpage__paragraph bolder">
              Provide a full explanation, with pictures, of what you believe happened
            </p>
          </div>

          <p className="subpage__paragraph">
            Damage is required to be reported within 24 hours of delivery. Customers are expected to continue making
            on-time payments and paying off their lease. While BuyOnTrust can offer no guarantees, the investigation
            period usually takes about 10 business days, after which time additional time is required if either a lease adjustment, cancellation, and/or reshipment is being provided.
          </p>
          <p className="subpage__paragraph">
            Thank you for your business, patience, and understanding as BuyOnTrust works diligently to support and respect all involved parties in these matters.
          </p>
          <p className="subpage__paragraph">
            BuyOnTrust appreciates your business, patience, and cooperation as we work to provide our customers with top-quality customer service. Customers are financially responsible for all items during pending investigations. BuyOnTrust reserves the right to issue, and/or not issue, refunds or lease adjustments at its discretion. Your financial obligations are also to your lease provider. BuyOnTrust yields to the lease provider for many final decisions. Customers are encouraged to speak with their lease provider regarding any financial matters, especially when their item is no longer returnable to the retail store. Restocking and/or rental fees may be applicable.
          </p>
        </p>
      </div>
    </main>
    </>
  );
}
